export default {
  'list-type': (h, conf, key) => {
    const list = []
    if (conf['list-type'] === 'picture-card') {
      list.push(<i class="el-icon-plus" style="font-size: 16px"></i>)
    }
    return list
  }
}

